var _clipPath, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenitiesIconsParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.11133 7.11133h17.7778v17.7778h-17.7778z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#3a9e9e",
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.5491 13.9629-1.2468-4.15604c-.2843-.94781-1.1399-1.5842-2.1289-1.5842h-8.3464c-.989 0-1.84458.63639-2.12887 1.5842l-1.24681 4.15604c-.78729.3421-1.33999 1.1256-1.33999 2.0375v4.4445c0 .6136.4975 1.1111 1.11111 1.1111h.00007l-.00007 1.111c0 .6137.49744 1.1112 1.11111 1.1112h1.11115c.6136 0 1.1111-.4975 1.1111-1.1111l-.0004-1.1111h8.8893l-.0001 1.111c0 .6137.4974 1.1112 1.1111 1.1112h1.1112c.6137 0 1.1111-.4975 1.1111-1.1111v-1.111l-.0004-.0001h.0004c.6136 0 1.1111-.4975 1.1111-1.1111v-4.4445c0-.9119-.5527-1.6954-1.34-2.0375zm-11.7221-3.518h8.3464l1 3.3333h-10.3464zm-.2713 8.3333c-.6136 0-1.1111-.4975-1.1111-1.1111 0-.6137.4975-1.1111 1.1111-1.1111.6137 0 1.1111.4974 1.1111 1.1111 0 .6136-.4974 1.1111-1.1111 1.1111zm8.8889 0c-.6136 0-1.1111-.4975-1.1111-1.1111 0-.6137.4975-1.1111 1.1111-1.1111.6137 0 1.1111.4974 1.1111 1.1111 0 .6136-.4974 1.1111-1.1111 1.1111z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenitiesIconsParking);
export default __webpack_public_path__ + "static/media/AmenitiesIconsParking.d25b7874db4112f75fd1f67b6c3f1f4e.svg";
export { ForwardRef as ReactComponent };